import {Observable, of} from 'rxjs';
import {EventEmitter, Output, ViewChild} from '@angular/core';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {withLatestFrom} from 'rxjs/operators';
import {SwiperInteractionButtonsComponent} from './swiper-interaction-buttons/swiper-interaction-buttons.component';

export interface Button {
  id: string;
  status?: string;
  iconClass?: string;
  title: string;
  isVisible: boolean;
  action: () => void;
}

export abstract class BaseInteractionButtonsComponent {
  @Output() updateEvent: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ViewChild('swiperInteractionButtonsComponent') swiperInteractionButtonsComponent: SwiperInteractionButtonsComponent;
  buttons: Observable<Array<Button>>;
  activeFormId = '';
  swiperConfig: SwiperConfigInterface = {
    a11y: true,
    direction: 'horizontal',
    keyboard: true,
    mousewheel: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    spaceBetween: 8,
  };

  protected constructor() {
  }

  formatPhoneForWhatsUp(phone: string) {
    return phone.replace('+', '');
  }

  toggleForm(event: string) {
    of(true).pipe(
      withLatestFrom(this.buttons)
    ).subscribe(
      ([_, buttons]) => {
        this.swiperInteractionButtonsComponent.swiperRef.directiveRef.nextSlide(buttons.findIndex((el: any) => el.id === event));
        this.activeFormId = this.activeFormId === event ? '' : event;
      }
    );
  }


  closeFormEvent(event: 'cancel' | 'success') {
    this.activeFormId = '';
    if (event === 'success') {
      this.updateEvent.emit(true);
    }
  }

  hasValue(value: any) {
    return value !== null && value !== undefined && value !== '';
  }
}
